module.exports = __webpack_public_path__ + "static/media/step-ladders.921e33ef.png";